import "basecoat-css/all";

type BasecoatRuntime = {
    initAll?: () => void;
    start?: () => void;
};

const initializeBasecoat = (): void => {
    const basecoat = (window as typeof window & { basecoat?: BasecoatRuntime }).basecoat;
    basecoat?.initAll?.();
    basecoat?.start?.();
};

// The deferred production script runs after parsing and before the larger Stimulus
// module. For an early blocking load, Basecoat's own DOMContentLoaded hook handles
// initialization; adding another hook here would register every listener twice.
if (document.readyState !== "loading") {
    initializeBasecoat();
}
